import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../lib/content";
import * as Icons from "lucide-react";

const Overline = ({ children }) => (
  <span className="inline-block font-sans text-[11px] md:text-xs uppercase tracking-[0.28em] text-[#C5A880] font-semibold">
    {children}
  </span>
);

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="border-b border-[#E2E8F0]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8">
            <Overline>Services</Overline>
            <h1 className="mt-8 font-serif text-5xl md:text-6xl lg:text-7xl tracking-tighter font-medium text-[#0A192F] leading-[0.98]">
              Financial expertise that <br />
              <span className="italic">grows with your business.</span>
            </h1>
          </div>
          <div className="lg:col-span-4 flex items-end">
            <p className="font-sans text-slate-600 leading-relaxed max-w-md">
              From bookkeeping to strategic CFO advisory, our services are designed to support
              every stage of your company&apos;s growth. Choose only what you need, and scale as your
              business evolves.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-[#E2E8F0]">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Circle;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="group relative border-b border-r border-[#E2E8F0] p-8 md:p-12 hover:bg-[#F8F9FA] transition-colors"
              >
                <div className="flex items-start justify-between">
                  <span className="font-sans text-xs tracking-[0.28em] text-[#C5A880]">
                    {s.number} / {String(SERVICES.length).padStart(2, "0")}
                  </span>
                  <ArrowUpRight
                    size={22}
                    strokeWidth={1.25}
                    className="text-slate-300 group-hover:text-[#0A192F] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                  />
                </div>
                <div className="mt-10">
                  <Icon size={28} strokeWidth={1.5} className="text-[#0A192F]" />
                </div>
                <h3 className="mt-6 font-serif text-2xl md:text-3xl text-[#0A192F] tracking-tight leading-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-[11px] tracking-[0.25em] uppercase text-slate-500">
                  {s.subtitle}
                </p>
                <p className="mt-6 font-sans text-slate-600 leading-relaxed max-w-md">
                  {s.description}
                </p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="bg-[#0A192F] text-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-8">
            <Overline>Not Sure Where to Start?</Overline>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl tracking-tighter leading-[1.05]">
              Book a 30-minute working session. <br />
              <span className="italic text-[#C5A880]">We&apos;ll map the right engagement.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <Link
              to="/contact"
              data-testid="services-cta-btn"
              className="inline-flex items-center gap-3 bg-[#C5A880] text-[#0A192F] px-8 py-4 font-sans text-[12px] tracking-[0.22em] uppercase hover:bg-white transition-all hover:-translate-y-0.5"
            >
              Schedule <ArrowUpRight size={16} strokeWidth={1.5} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
